module.exports = "/_next/static/images/Connections@3x-ce7210eacf08c6970d80832dc2b2c06c.webp";